import React from "react";
import dayjs from "dayjs";
import { AccessEditButton } from "../../constants/PermissionSet";
import { IsAuthorized, useAuthorization } from "meportal/AuthorizationProvider";

interface AlertNotificationProps {
    data: any;
    category: any; 
    alertNotificationCLicked: (event: any) => void;
}

export const AlertNotification: React.FC<AlertNotificationProps>= ({ data, category, alertNotificationCLicked }) => {
    const { eventPermissions, userClaims } = useAuthorization();

    const TimeConvertion = (time) => {
        const minsinhour = 60;
        const minsinday = 1440;
        if (time < 1)
        {
            return "Now";
        }
        else if (time < minsinhour) {
            return time + "m ago";
        }
        else if (time < minsinday){
            return Math.floor(time / minsinhour) + "h ago";
        }
        else{
            return Math.floor(time / minsinday) + "d ago";
        }

    }

    const formatTime = (inputTime: string, isTime: boolean) => {
        const convertedTime = dayjs.utc(inputTime).local();
        // dividing the input time into two components, date and time.
        if (isTime) {
            return convertedTime.format("HH:mm");
        } else {
            return convertedTime.format("MM/DD/YY");
        }
    };

    return (
        <div className="overdue_events">
            <span className="title_events">{category}</span>
            {data.map((event, index) => {
                    return (
                        <div className={`event_container ${IsAuthorized(event.Airline + ":" + event.EventType, AccessEditButton, eventPermissions, userClaims ) ? '' : ' alert-modal-no-click'}`} 
                        onClick={() => IsAuthorized(event.Airline + ":" + event.EventType, AccessEditButton, eventPermissions, userClaims ) ? alertNotificationCLicked(event) : undefined} key={index} role="button" tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && IsAuthorized(event.Airline + ":" + event.EventType, AccessEditButton, eventPermissions, userClaims)) {
                               alertNotificationCLicked(event)
                            }}}>
                            {category === "Overdue Events" && (
                                <svg className="alert-svg" width="36" height="35" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g id="Alert/Filled/warning-filled">
                                        <path id="warning-filled" fillRule="evenodd" clipRule="evenodd" d="M15 3C21.9036 3 27.5 8.59644 27.5 15.5C27.5 22.4036 21.9036 28 15 28C8.09644 28 2.5 22.4036 2.5 15.5C2.5 8.59644 8.09644 3 15 3ZM15 19.875C14.4822 19.875 14.0625 20.2947 14.0625 20.8125C14.0625 21.3303 14.4822 21.75 15 21.75C15.5178 21.75 15.9375 21.3303 15.9375 20.8125C15.9375 20.2947 15.5178 19.875 15 19.875ZM15 9.25C14.5254 9.25 14.1331 9.60269 14.0711 10.0603L14.0625 10.1875V18L14.0711 18.1272C14.1331 18.5848 14.5254 18.9375 15 18.9375C15.4746 18.9375 15.8669 18.5848 15.9289 18.1272L15.9375 18V10.1875L15.9289 10.0603C15.8669 9.60269 15.4746 9.25 15 9.25Z" fill="#DB0B00" />
                                    </g>
                                </svg>
                            )}
                            {category === "Within 5 mins" && (
                                <svg className="alert-svg" width="36" height="35" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g id="fluent:warning-32-filled">
                                        <path id="Vector" d="M17.8725 4.07094C16.6238 1.81156 13.3763 1.81156 12.1275 4.07094L2.29034 21.8825C1.08284 24.0687 2.66534 26.75 5.16284 26.75H24.8382C27.3357 26.75 28.9182 24.0687 27.7097 21.8825L17.8725 4.07094ZM16.1719 21.125C16.1719 21.4358 16.0484 21.7339 15.8287 21.9536C15.6089 22.1734 15.3108 22.2969 15 22.2969C14.6892 22.2969 14.3912 22.1734 14.1714 21.9536C13.9516 21.7339 13.8282 21.4358 13.8282 21.125C13.8282 20.8142 13.9516 20.5161 14.1714 20.2964C14.3912 20.0766 14.6892 19.9531 15 19.9531C15.3108 19.9531 15.6089 20.0766 15.8287 20.2964C16.0484 20.5161 16.1719 20.8142 16.1719 21.125ZM15 8.9375C15.2487 8.9375 15.4871 9.03627 15.6629 9.21208C15.8388 9.3879 15.9375 9.62636 15.9375 9.875V17.375C15.9375 17.6236 15.8388 17.8621 15.6629 18.0379C15.4871 18.2137 15.2487 18.3125 15 18.3125C14.7514 18.3125 14.5129 18.2137 14.3371 18.0379C14.1613 17.8621 14.0625 17.6236 14.0625 17.375V9.875C14.0625 9.62636 14.1613 9.3879 14.3371 9.21208C14.5129 9.03627 14.7514 8.9375 15 8.9375Z" fill="#DE750C" />
                                    </g>
                                </svg>
                            )}

                            <div className="overdueevent">
                                <div className="section1">
                                    <div className="flightdata">
                                        <span className="flight_aircraft">{event.AircraftRegistration}</span>
                                        <div className="vl-notify"></div>
                                        <span className="flight_station">{event.Station}</span>
                                        <span className="flight_adv_etr_time">{event.AdviseTimeUTC != null ? "ADV: " + formatTime(event.AdviseTimeUTC, true) : "ETR: " + formatTime(event.EstimatedReturnToServiceTimeUTC, true)}</span>
                                    </div>
                                    <div className="timeoverdue">
                                        <span>{TimeConvertion(event.alertTimeDiffInMins)}</span>
                                    </div>
                                </div>
                                <div className="section2">
                                    <span className="section2-problem-statement">{event.ProblemText}</span>
                                </div>
                            </div>
                        </div>
                    );
            })}
        </div>
    );
}